module.exports = __webpack_public_path__ + "static/media/Minus.70de1a0e.svg";